import React, { Component } from 'react';
import Spin from '../../../../commonModules/interface/Spin';
import { isEmpty } from 'lodash'
import { ListLayout } from '../../../Menu/Stock/containers/Layout';
import { TableHead, TableBody, TableRow, TableCell, Box, Typography, IconButton, CircularProgress } from '@material-ui/core';
import { Autorenew } from '@material-ui/icons';

const NATURE = {
    "commercial": "Reappro",
    "rectif": "Retour",
    "payg": "Vente PayG"
}
class CommercialHistory extends Component {
    state = {  }
    render() {
        const { history, loading } = this.props;
        console.log('====================================');
        console.log({history});
        console.log('====================================');
        return (
            <Box>
                {(!history || loading) ?
                    <CircularProgress color="secondary" size={60} style={{textAlign:"center"}} />
                :
                    <Box style={{ textAlign: "right"}}>
                        <IconButton color="secondary" onClick={this.props.refreshData}>
                            <Autorenew />
                        </IconButton>

                        {!isEmpty(history) && 
                            <ListLayout>
                                <TableHead>
                                    <TableRow>
                                        <TableCell component="th">Date</TableCell>
                                        <TableCell component="th">Opération</TableCell>
                                        <TableCell component="th">Nom</TableCell>
                                        <TableCell component="th">Référence</TableCell>
                                        <TableCell component="th">Quantité</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {history.map( (op, i) => 
                                        <TableRow 
                                            key={`${op.history_product}_${i}`} 
                                            className={ op.operation !== "commercial" && "red"}
                                        >
                                            <TableCell>{new Date(op.history_date).toLocaleDateString("fr-FR")}</TableCell>
                                            <TableCell>{NATURE[op.operation]}</TableCell>
                                            <TableCell>{op.product && op.product.name}</TableCell>
                                            <TableCell>{op.product && op.product.ref}</TableCell>
                                            <TableCell>{op.operation === "commercial" ? op.history_quantity : (op.history_quantity * -1)}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </ListLayout>
                        }
                    </Box>
                }
                
            </Box>
        );
    }
}

export default CommercialHistory;